const map = {
	"./billet.png": 8084,
	"./box.png": 5893,
	"./brazil.png": 6654,
	"./detail-left.png": 2885,
	"./detail-right.png": 2422,
	"./groups.png": 8380,
	"./logs.png": 8161,
	"./money.png": 7478,
	"./paper.png": 4816,
	"./pin.png": 9727,
	"./refresh.png": 4431,
	"./search.png": 9224,
	"./truck.png": 6171
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7287;